import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './Form';
import { fetchUserList } from '@app/src/views/Users/list/state/userList/actions';

const Container = reduxForm({
  form: 'filterUser',
  onSubmit (fields, dispatch, url) {
    dispatch(fetchUserList(fields, url));
  }
})(Form);

const mapStateToProps = state => ({
  valuesForm: getFormValues('filterUser')(state)
});

const mapDispatchToProps = dispatch => ({
  handleFetchDetail: (filter: object, url: string) => dispatch(fetchUserList({ ...filter }, url))
});

export const FormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
